import Vue from 'vue'
import App from './App.vue'
import router from './router'
import _ from 'lodash'
import store from './store'
// import './plugins/element.js'
import './plugins/axios'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/base.scss'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import search from '@/components/el-Search'
import tables from '@/components/el-Table'
import rules from '@/plugins/verifications'
import * as Httprequest from '@/api/request.js'
// 存储数据
import { department, Region, UserCenterdRouter, Subsystem, uploadUrl } from '@/api/commonhttp'
import { message } from '@/plugins/element.js'
import Pagination from '@/components/pagination'
import { tableToExcel } from '@/utils/xlsx.js'
import { Layoutfun } from '@/plugins/ProcessingofSelectData.js'
import autocomplete from '@/plugins/autocomplete.js'
Vue.config.productionTip = false
Vue.prototype._ = _
// 封装 全局搜索框
Vue.component('search', search)
// 封装 全局table表格
Vue.component('tables', tables)
// 封装 全局分页
Vue.component('Pagination', Pagination)
// 封装 全局验证
Vue.prototype.$rules = rules
// 封装 请求
Vue.prototype.$http = Httprequest
// 封装 全局弹框
Vue.prototype.$message = message
// 封装 全局的导出
Vue.prototype.$tableToExcel = tableToExcel
Vue.prototype.$Layoutfun = Layoutfun
// 封装 公共接口方法
Vue.prototype.$department = department // 部门
Vue.prototype.$Region = Region // 地区
Vue.prototype.$UserCenterdRouter = UserCenterdRouter // 动态路由
Vue.prototype.$Subsystem = Subsystem // 子系统
Vue.prototype.$uploadUrl = uploadUrl // 导出
// 封装input输入建议
Vue.prototype.$autocomplete = autocomplete

new Vue({
  router,
  store,
  base: 'web/userCenter',
  mode: 'hash',
  render: h => h(App)
}).$mount('#app')
